module.exports = __webpack_public_path__ + "img/video.296bc648.svg";